export enum LOYALTY_APPLY_STATUS {
  PROCESSING = 'PROCESSING',
  INVALID = 'INVALID',
  SUCCESS = 'SUCCESS',
}
